export default __webpack_public_path__ + "static/media/tac5.9a6be881.jpg";